import { createFileRoute } from '@tanstack/react-router'
import { MealEditPage } from '@/components/meal-edit-page'

export const Route = createFileRoute('/meal/$mealId')({ component: MealEditPage })
